export default "__VITE_ASSET__bcVN$vyy__"